// extracted by mini-css-extract-plugin
module.exports = {"vnrPostGroup":"PostGroup_vnrPostGroup__uftp3","readMorePostGroup":"PostGroup_readMorePostGroup__3TwJb","readMoreText":"PostGroup_readMoreText__3261E"};